var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.iso)?_c('span',{staticClass:"flag-icon",class:_vm.flagIconClass,style:('background-image: url(\'/img/icons/flags/3x2/' + _vm.iso.toUpperCase() + '.svg\')'),attrs:{"title":_vm.title || _vm.iso}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }